module.exports = __webpack_public_path__ + "media/images/logo-375-331c00d1bde50b877dfc7072e0a47ea0.jpg";